// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"b1603aea","228":"42172801","616":"e7e71b9a","855":"d85bbdf2"}[chunkId] + ".chunk.js";
};